/* RAAE Journal
   <journal-video>: autoplay uden lyd når filmen er synlig, lydknapper, pause og tidslinje. */
(() => {
  if (window.raaeJournalLoaded) return;
  window.raaeJournalLoaded = true;

  const fmt = (s) => {
    if (!isFinite(s)) return '0:00';
    const m = Math.floor(s / 60);
    const r = Math.floor(s % 60);
    return `${m}:${String(r).padStart(2, '0')}`;
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class JournalVideo extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.scrub = this.querySelector('[data-scrub]');
      this.current = this.querySelector('[data-current]');
      this.duration = this.querySelector('[data-duration]');
      this.toggleBtn = this.querySelector('[data-toggle]');
      this.soundBtns = this.querySelectorAll('[data-sound]');
      this.soundLabel = this.querySelector('[data-sound-label]');
      this.userPaused = false;
      this.scrubbing = false;
      this.autoplay = !this.hasAttribute('data-no-autoplay');
      this.labelOn = this.dataset.labelOn || 'Slå lyd til';
      this.labelOff = this.dataset.labelOff || 'Slå lyd fra';

      this.video.muted = true;
      this.toggleBtn.addEventListener('click', () => this.toggle());
      this.soundBtns.forEach((b) => b.addEventListener('click', () => this.setSound(this.video.muted)));

      this.video.addEventListener('loadedmetadata', () => {
        this.scrub.max = String(this.video.duration || 0);
        this.duration.textContent = fmt(this.video.duration);
      });
      this.video.addEventListener('timeupdate', () => {
        if (!this.scrubbing) this.scrub.value = String(this.video.currentTime);
        this.current.textContent = fmt(this.video.currentTime);
      });
      this.video.addEventListener('play', () => this.syncPlay());
      this.video.addEventListener('pause', () => this.syncPlay());

      this.scrub.addEventListener('input', () => {
        this.scrubbing = true;
        this.video.currentTime = Number(this.scrub.value);
        this.current.textContent = fmt(this.video.currentTime);
      });
      this.scrub.addEventListener('change', () => { this.scrubbing = false; });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && e.intersectionRatio >= 0.5) {
              if (this.autoplay && !this.userPaused && !reduceMotion.matches) this.play();
            } else if (!this.video.paused) {
              this.video.pause();
            }
          });
        }, { threshold: [0, 0.5] });
        this.observer.observe(this);
      }
      this.syncPlay();
      this.syncSound();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play() {
      const p = this.video.play();
      if (p && p.catch) p.catch(() => {});
    }

    toggle() {
      if (this.video.paused) {
        this.userPaused = false;
        this.play();
      } else {
        this.userPaused = true;
        this.video.pause();
      }
    }

    setSound(on) {
      if (on) {
        document.querySelectorAll('journal-video').forEach((v) => {
          if (v !== this && v.video && !v.video.muted) v.setSound(false);
        });
        this.userPaused = false;
        this.play();
      }
      this.video.muted = !on;
      this.syncSound();
    }

    syncPlay() {
      const playing = !this.video.paused;
      this.toggleAttribute('data-playing', playing);
      this.toggleBtn.setAttribute('aria-label', playing ? 'Pause' : 'Afspil');
    }

    syncSound() {
      const on = !this.video.muted;
      this.toggleAttribute('data-sound-on', on);
      this.soundBtns.forEach((b) => {
        b.setAttribute('aria-pressed', String(on));
        if (!b.querySelector('[data-sound-label]')) b.setAttribute('aria-label', on ? this.labelOff : this.labelOn);
      });
      if (this.soundLabel) this.soundLabel.textContent = on ? this.labelOff : this.labelOn;
    }
  }

  if (!customElements.get('journal-video')) customElements.define('journal-video', JournalVideo);
})();
